import { Directive, ElementRef, Renderer2 } from "@angular/core";
import { PlatformService } from "@obg/ngx.global.evo";

const SSR_CLASS_NAME = "obg-server";

/**
 * Adds class to element on server which is removed when client takes over.
 *
 * Example use case: hide component which layout can't be computed on server (screen width unknown for js computation)
 */
@Directive({
	selector: "[obgServerStyle]",
})
export class ServerStyleDirective {
	constructor(el: ElementRef, renderer: Renderer2, platformService: PlatformService) {
		if (platformService.isServer) {
			renderer.addClass(el.nativeElement, SSR_CLASS_NAME);
		} else {
			renderer.removeClass(el.nativeElement, SSR_CLASS_NAME);
		}
	}
}
